import React from "react";
import PhoneInput from "react-phone-input-2";
import { callApi, validateToken } from "../../lib/utils";
import axios from "axios";
import { withRouter, BrowserRouter as Router, Route } from "react-router-dom";
import { connect } from "react-redux";
import {
  Row,
  Col,
  Form,
  Card,
  Nav,
  Navbar,
  Button,
  Accordion,
} from "react-bootstrap";
import { css } from "aphrodite";
import async from "async";
import SideMenuComponentsHeader from "../GenericComponents/Headers/SideMenuComponentsHeader";
import CustomAccordion from "../GenericComponents/CustomAccordion";
import SideBar from "../GenericComponents/Headers/SideBar";
import CustomLoader from "../GenericComponents/CustomLoader";
import TextField from "../GenericComponents/TextField";
import TextArea from "../GenericComponents/TextArea";
import CustomModal from "../GenericComponents/CustomModal";
import SelectField from "../GenericComponents/SelectField";
import Footer from "../GenericComponents/Footer";
import styles from "./style";
import "./faqs.css";

class faqs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      faqCategories: [],
      faqList: [],
      categoryWiseFaqs: [],
      customModal: false,
      msg: "",
      subscriptionCancellationReasons: [],
      selectedReason: [],
      activeTabKey: "cat1",
      formInputs: {
        name: `${props.profileData.patientData.firstName} ${props.profileData.patientData.lastName}`,
        email: props.profileData.patientData.email,
        phone: `${props.profileData.patientData.countryCode} ${props.profileData.patientData.mobileNumber}`,
        subject: "",
        message: "",
        subsCancellationReason: "",
        otherReason: "",
        cancellationComment: "",
      },
    };
  }

  componentDidMount() {
    // Check if the component was loaded with the state to open the cancellation tab
    const locationState = this.props.location.state;
    if (locationState && locationState.openCancellationTab) {
      var elems = document.getElementById("cat3");
      elems.classList.add("is-open");
      this.setState({ activeTabKey: "cat3" });
    } else {
      var elems = document.getElementById("cat1");
      elems.classList.add("is-open");
    }

    validateToken((err) => {
      if (err) {
        window.location = "/logout";
      }
      this.fetchData();
    });
  }

  // componentDidMount() {
  //   //localStorage.removeItem("redux_localstorage_simple_appstate");
  //   var elems = document.getElementById("cat1");
  //   elems.classList.add("is-open");

  //   validateToken((err) => {
  //     if (err) {
  //       window.location = "/logout";
  //     }
  //     this.fetchData();
  //   });
  // }

  fetchData = () => {
    this.setState({ loading: true });
    async.parallel([
      // () => {
      //   callApi(`/api/faq/category/list`, {}, "GET")
      //     .then((response) => {
      //       let faqCategories = response.data.data.categories;
      //       this.setState({ faqCategories, loading: false });
      //     })
      //     .catch((err) => {
      //       this.setState({ loading: false });
      //     });
      // },
      // () => {
      //   callApi(`/api/faq/list`, {}, "GET")
      //     .then((response) => {
      //       let faqList = response.data.data.faqs;
      //       this.setState({ faqList, loading: false }, () => {
      //         this.defaultValue();
      //       });
      //     })
      //     .catch((err) => {
      //       this.setState({ loading: false });
      //     });
      // },
      () => {
        callApi(
          `/api/admin/entity/subscription/cancellation/reason/list`,
          {},
          "GET"
        )
          .then((response) => {
            //console.log("response...", response);
            let reasons = response.data.data.subscriptionCancellationReasons;
            let subscriptionCancellationReasons = [];
            reasons.map((val) => {
              subscriptionCancellationReasons.push({
                id: val.id,
                name: val.cancellationReason,
                isOther: val.isOther,
              });

              return subscriptionCancellationReasons;
            });
            this.setState({ subscriptionCancellationReasons, loading: false });
          })
          .catch((err) => {
            this.setState({ loading: false });
          });
      },
    ]);
  };

  defaultValue = () => {
    let category = "";
    let categoryWiseFaqs = [];
    if (this.state.faqCategories.length > 0) {
      category = this.state.faqCategories[0].id;
      this.state.faqList
        .filter((val) => {
          return val.faqCategoryId === category;
        })
        .forEach((faqs) => {
          categoryWiseFaqs.push(faqs);
        });

      var elems = document.getElementById(category);
      //console.log("elems...", elems);
      elems.classList.add("nav-hover");
    }

    this.setState({ categoryWiseFaqs });
  };

  hoverOn = (e) => {
    //console.log("hoverOn....", e.target.value);
    let category = e.target.value;
    let categoryWiseFaqs = [];
    this.state.faqList
      .filter((val) => {
        return val.faqCategoryId === category;
      })
      .forEach((faqs) => {
        categoryWiseFaqs.push(faqs);
      });

    //console.log(categoryWiseFaqs);
    var elems = document.querySelectorAll(".acc-btn.is-open");

    [].forEach.call(elems, function (el) {
      el.classList.remove("is-open");
    });

    this.state.faqCategories.forEach((val) => {
      var elems = document.getElementById(val.id);
      if (val.id === category) elems.classList.add("nav-hover");
      else elems.classList.remove("nav-hover");
    });

    this.setState({ categoryWiseFaqs });
  };

  handleChange = (e) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;
    let formInputs = { ...this.state.formInputs };
    let selectedReason = [...this.state.selectedReason];

    if (fieldName === "subsCancellationReason") {
      selectedReason = this.state.subscriptionCancellationReasons.filter(
        (val) => {
          return val.id === parseInt(fieldValue);
        }
      );
    }
    formInputs[fieldName] = fieldValue;
    this.setState({
      formInputs,
      selectedReason,
    });
  };

  setPhoneNumber = (data) => {
    //console.log("data...",data);
    let formInputs = { ...this.state.formInputs };
    formInputs["phone"] = data;

    this.setState({
      formInputs,
    });
  };

  submitSupportData = (e) => {
    e.preventDefault();
    let formInputs = { ...this.state.formInputs };

    let params = {
      name: formInputs.name,
      phoneNumber: formInputs.phone,
      email: formInputs.email,
      subject: formInputs.subject,
      message: formInputs.message,
    };
    this.setState({ loading: true });
    callApi(`/api/support/contact`, params, "POST")
      .then((response) => {
        //let faqList = response.data.data.faqs;
        //console.log("response....", response);
        if (response.status === 200)
          this.setState({
            loading: false,
            customModal: true,
            msg: "Thank you for contacting us, we will get back to you as soon as possible.",
          });
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };

  submitSubsCancellationData = (e) => {
    e.preventDefault();
    let formInputs = { ...this.state.formInputs };

    let params = {
      patientId: this.props.profileData.id,
      email: this.props.profileData.patientData.email,
      cancellationReasonId: parseInt(formInputs.subsCancellationReason),
      otherCancellationReason: formInputs.otherReason,
      comments: formInputs.cancellationComment,
    };

    this.setState({ loading: true });
    callApi(`/api/patient/subscription/request/cancellation`, params, "POST")
      .then((response) => {
        //let faqList = response.data.data.faqs;
        //console.log("response....", response);
        if (response.status === 200)
          this.setState({
            loading: false,
            customModal: true,
            msg: "Request for subscription cancellation submitted successfully.",
          });
        else this.setState({ loading: false });
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };

  handleModal = () => {
    this.setState({ customModal: !this.state.customModal });
    this.props.history.push("/dashboard");
  };

  checkPhoneValidation = (value, country) => {
    //console.log("value...", value);
    //console.log("country...", country);

    if (value.match(/12345/)) {
      return "Invalid value: " + value + ", " + country.name;
    } else if (value.match(/1234/)) {
      return false;
    } else {
      return true;
    }
  };

  render() {
    return (
      <container>
        <CustomModal
          header={""}
          name={""}
          size={"sm"}
          title={this.state.msg}
          show={this.state.customModal}
          confirmButtons={false}
          action={this.handleModal}
        />
        <CustomLoader loading={this.state.loading} />
        <SideMenuComponentsHeader title={"Help & Support"} />
        <div className="faqs-page-content">
          <Row className={`${css(styles.mainGrid)} faqs-main`}>
            <Col xs={12} className="px-0">
            <Accordion activeKey={this.state.activeTabKey} onSelect={(key) => this.setState({ activeTabKey: key })} flush style={{ padding: "0px", width: "100%" }}>
              <Card style={{ marginBottom: "1em", border: "none" }}>
                <div className="faqs-tab-nav">
                  <CustomAccordion eventKey="cat1">
                    <button
                      id={"cat1"}
                      className="cat-btn"
                    //className="acc-btn"
                    >
                      FAQs
                    </button>
                  </CustomAccordion>
                  <CustomAccordion eventKey="cat2">
                    <button
                      id={"cat2"}
                      className="cat-btn"
                    //className="acc-btn"
                    >
                      Contact Support
                    </button>
                  </CustomAccordion>
                  {this.props.patientSubscription !== null && (
                    <CustomAccordion eventKey="cat3">
                      <button
                        id={"cat3"}
                        className="cat-btn"
                      //className="acc-btn"
                      >
                        Request for Subscription Cancellation
                      </button>
                    </CustomAccordion>
                  )}
                </div>
                <Accordion.Collapse eventKey="cat1">
                  <Row className="faqs-section g-0">
                    <Col xs={12}>
                      <div className="faqs-info-box">
                        <a href="https://smart-monitor.com/inspyre-faqs/" target="_blank" rel="noopener noreferrer">Click here</a> to view the FAQs.
                      </div>
                    </Col>
                  </Row>

                  { /* <Row className={css(styles.secondGrid)}>
                    <span style={{ textAlign: "center" }}><a href="https://smart-monitor.com/inspyre-faqs/" target="_blank">Click here</a> to check the FAQs.</span>
                     <Col
                      xs={12}
                      sm={6}
                      md={2}
                      className={css(styles.sideStyle)}
                    >
                      <Navbar style={{ display: "block", padding: "0px" }}>
                        <Nav className="flex-column">
                          {this.state.faqCategories.length !== 0 &&
                            this.state.faqCategories.map((cat) => {
                              return (
                                <Nav.Link
                                  as={"li"}
                                  name={cat.categoryName}
                                  value={cat.id}
                                  id={cat.id}
                                  className={css(styles.navStyle)}
                                  onMouseOver={this.hoverOn}
                                >
                                  {cat.categoryName}
                                </Nav.Link>
                              );
                            })}
                        </Nav>
                      </Navbar>
                    </Col>
                    <Col
                      xs={12}
                      sm={6}
                      md={10}
                      style={{ height: "75vh", overflowY: "scroll" }}
                    >
                      <Accordion defaultActiveKey="0" flush>
                        {this.state.categoryWiseFaqs !== 0 &&
                          this.state.categoryWiseFaqs.map((lst, index) => {
                            return (
                              <Card style={{ marginBottom: "1em" }}>
                                <CustomAccordion eventKey={lst.id}>
                                  <button id={lst.id} className="acc-btn">
                                    {lst.faq}
                                  </button>
                                </CustomAccordion>

                                <Accordion.Collapse eventKey={lst.id}>
                                  <div className="acc-content">
                                    <p>{lst.answer}</p>
                                  </div>
                                </Accordion.Collapse>
                              </Card>
                            );
                          })}
                      </Accordion>
                    </Col> 
                  </Row>*/}
                </Accordion.Collapse>

                <Accordion.Collapse eventKey="cat2">
                  <Row className={css(styles.secondGrid)}>
                    <Col xs={12}>
                    <Form autoComplete="off" onSubmit={this.submitSupportData}>
                      <Row className="faqs-form-row g-3">
                        <Col xs={12} md={6}>
                          <TextField
                            type={"text"}
                            placeholder={"Your Name*"}
                            name={"name"}
                            value={this.state.formInputs.name}
                            className={css(styles.textFieldClass)}
                            action={this.handleChange}
                            isAlphaNumeric={true}
                            //className={"patient-input"}
                            required={true}
                          />
                        </Col>
                        <Col xs={12} md={6}>
                          <TextField
                            type={"email"}
                            placeholder={"Your Email*"}
                            name={"email"}
                            value={this.state.formInputs.email}
                            className={css(styles.textFieldClass)}
                            action={this.handleChange}
                            //isEmail={true}
                            //className={"patient-input"}
                            required={true}
                          />
                        </Col>
                      </Row>
                      <Row className="faqs-form-row g-3">
                        <Col xs={12} md={6}>
                          {/* <TextField
                            type={"text"}
                            placeholder={"Phone"}
                            name={"phone"}
                            value={this.state.formInputs.phone}
                            className={css(styles.textFieldClass)}
                            action={this.handleChange}
                            //className={"patient-input"}
                            //required={true}
                          /> */}
                          <PhoneInput
                            country={"us"}
                            value={this.state.formInputs.phone}
                            inputClass={"tel-input"}
                            enableSearch={true}
                            isValid={(value, country) =>
                              this.checkPhoneValidation(value, country)
                            }
                            onChange={(phone) => this.setPhoneNumber(phone)}
                          />
                        </Col>
                        <Col xs={12} md={6}>
                          <TextField
                            type={"text"}
                            placeholder={"Subject*"}
                            name={"subject"}
                            value={this.state.formInputs.subject}
                            className={css(styles.textFieldClass)}
                            action={this.handleChange}
                            isAlphaNumeric={true}
                            //className={"patient-input"}
                            required={true}
                          />
                        </Col>
                      </Row>
                      <Row className="faqs-form-row g-3">
                        <Col xs={12}>
                          <TextArea
                            rows={5}
                            placeholder={"Message*"}
                            name={"message"}
                            maxLength={251}
                            value={this.state.formInputs.message}
                            className={css(styles.textAreaClass)}
                            action={this.handleChange}
                            isSpecialAlphaNumeric={true}
                            required={true}
                          />
                        </Col>
                      </Row>
                      <Row className="faqs-form-row g-3">
                        <Col xs={12}>
                          <div style={{ textAlign: "center" }}>
                            <Button
                              variant="primary"
                              type="submit"
                              className={css(styles.buttonClass)}
                            >
                              Submit
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                    </Col>
                  </Row>
                </Accordion.Collapse>
                <Accordion.Collapse eventKey="cat3">
                  {this.props.patientSubscription.cancellationRequested ? (
                    <Row className="faqs-section g-0">
                      <Col xs={12}>
                        <div className="faqs-info-box faqs-info-box--error">
                          {
                            "We've received your service cancellation request. For any questions or changes, please contact support@smart-monitor.com"
                          }
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <Row className={css(styles.secondGrid)}>
                      <Col xs={12}>
                      <Form
                        autoComplete="off"
                        onSubmit={this.submitSubsCancellationData}
                      >
                        <Row className="faqs-form-row g-3">
                          <Col xs={12} md={8} lg={6}>
                            <Form.Group className="mb-3">
                              <Form.Label className={css(styles.labels)}>
                                Cancellation Reason
                              </Form.Label>
                              <SelectField
                                name={"subsCancellationReason"}
                                options={
                                  this.state.subscriptionCancellationReasons
                                }
                                value={
                                  this.state.formInputs.subsCancellationReason
                                }
                                defaultValue={
                                  this.state.formInputs.subsCancellationReason
                                }
                                action={this.handleChange}
                                //className={"patient-input"}
                                required={true}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        {this.state.selectedReason.length !== 0 &&
                          this.state.selectedReason[0].isOther && (
                            <Row className="faqs-form-row g-3">
                              <Col xs={12} md={8} lg={6}>
                                <Form.Group className="mb-3">
                                  <Form.Label className={css(styles.labels)}>
                                    Specify Other Reason
                                  </Form.Label>
                                  <TextArea
                                    rows={3}
                                    placeholder={"Other reason*"}
                                    name={"otherReason"}
                                    maxLength={251}
                                    value={this.state.formInputs.otherReason}
                                    className={css(styles.subsTextAreaClass)}
                                    action={this.handleChange}
                                    isSpecialAlphaNumeric={true}
                                    required={true}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                          )}

                        <Row className="faqs-form-row g-3">
                          <Col xs={12} md={8} lg={6}>
                            <Form.Group className="mb-3">
                              <Form.Label className={css(styles.labels)}>
                                Comments / Notes
                              </Form.Label>
                              <TextArea
                                rows={3}
                                placeholder={"Cancellation Comments / Notes*"}
                                name={"cancellationComment"}
                                maxLength={251}
                                value={
                                  this.state.formInputs.cancellationComment
                                }
                                className={css(styles.subsTextAreaClass)}
                                action={this.handleChange}
                                isSpecialAlphaNumeric={true}
                                required={true}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className="faqs-form-row--compact g-3">
                          <Col xs={12} md={8} lg={6}>
                            <div style={{ textAlign: "center" }}>
                              <Button
                                variant="primary"
                                type="submit"
                                className={css(styles.buttonClass)}
                              >
                                Submit
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                      </Col>
                    </Row>
                  )}
                </Accordion.Collapse>
              </Card>
            </Accordion>
            </Col>
          </Row>
          <Footer />
        </div>
      </container>
    );
  }
}

export default connect(
  (store) => {
    return {
      profileData: store.dashboard.profileData,
      patientSubscription: store.dashboard.patientSubscription,
    };
  },
  (dispatch) => {
    return {
      //   setAbnormalSettingsData: (abnormalMotionSettings) => {
      //     dispatch({
      //       type: "SET_ABNORMAL_MOTION_SETTINGS",
      //       payload: { abnormalMotionSettings },
      //     });
      //   },
    };
  }
)(withRouter(faqs));
